"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
var id = 0;
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.generateChars = function (length) {
        var chars = '';
        for (var i = 0; i < length; i++) {
            var randomChar = Math.floor(Math.random() * 36);
            chars += randomChar.toString(36);
        }
        return chars;
    };
    Utils.bind = function (func, context) {
        return function () {
            func.apply(context, arguments);
        };
    };
    Utils._convertData = function (data) {
        for (var originalKey in data) {
            if (data.hasOwnProperty(originalKey)) {
                var keys = originalKey.split('-');
                var dataLevel = data;
                if (keys.length === 1) {
                    continue;
                }
                for (var k = 0; k < keys.length; k++) {
                    var key = keys[k];
                    // Lowercase the first letter
                    // By default, dash-separated becomes camelCase
                    key = key.substring(0, 1).toLowerCase() + key.substring(1);
                    if (!(key in dataLevel)) {
                        dataLevel[key] = {};
                    }
                    if (k === keys.length - 1) {
                        dataLevel[key] = data[originalKey];
                    }
                    dataLevel = dataLevel[key];
                }
                delete data[originalKey];
            }
        }
        return data;
    };
    Utils.hasScroll = function (el, index) {
        var overflowX = el.style.overflowX;
        var overflowY = el.style.overflowY;
        // Check both x and y declarations
        if (overflowX === overflowY && (overflowY === 'hidden' || overflowY === 'visible')) {
            return false;
        }
        if (overflowX === 'scroll' || overflowY === 'scroll') {
            return true;
        }
        return (parseInt(window.getComputedStyle(el).height, 10) < el.scrollHeight ||
            parseInt(window.getComputedStyle(el).width, 10) < el.scrollWidth);
    };
    Utils.GetUniqueElementId = function (element) {
        // Get a unique element Id. If element has no id,
        // creates a new unique number, stores it in the id
        // attribute and returns the new id with a prefix.
        // If an id already exists, it simply returns it with a prefix.
        var select2Id = element.getAttribute('data-select2-id');
        if (select2Id != null) {
            return select2Id;
        }
        // If element has id, use it.
        if (element.id) {
            select2Id = 'select2-data-' + element.id;
        }
        else {
            select2Id = 'select2-data-' + (++id).toString() + '-' + Utils.generateChars(4);
        }
        element.setAttribute('data-select2-id', select2Id);
        return select2Id;
    };
    Utils.StoreData = function (element, name, value) {
        // Stores an item in the cache for a specified element.
        // name is the cache key.
        var _id = Utils.GetUniqueElementId(element);
        if (!Utils.__cache[_id]) {
            Utils.__cache[_id] = {};
        }
        Utils.__cache[_id][name] = value;
    };
    Utils.GetData = function (element, name) {
        // Retrieves a value from the cache by its key (name)
        // name is optional. If no name specified, return
        // all cache items for the specified element.
        // and for a specified element.
        var _id = Utils.GetUniqueElementId(element);
        if (name) {
            if (Utils.__cache[_id]) {
                if (Utils.__cache[_id][name] != null) {
                    return Utils.__cache[_id][name];
                }
                return element.dataset[name]; // Fallback to HTML5 data attribs.
            }
            return element.dataset[name]; // Fallback to HTML5 data attribs.
        }
        else {
            return Utils.__cache[id];
        }
    };
    Utils.RemoveData = function (element) {
        // Removes all cached items for a specified element.
        var _id = Utils.GetUniqueElementId(element);
        if (Utils.__cache[_id] != null) {
            delete Utils.__cache[_id];
        }
        element.removeAttribute('data-select2-id');
    };
    Utils.copyNonInternalCssClasses = function (dest, src) {
        var destinationClasses = dest.getAttribute('class').trim().split(/\s+/);
        destinationClasses = destinationClasses.filter(function (clazz) {
            // Save all TsSelect2 classes
            return clazz.indexOf('select2-') === 0;
        });
        var sourceClasses = src.getAttribute('class').trim().split(/\s+/);
        sourceClasses = sourceClasses.filter(function (clazz) {
            // Only copy non-TsSelect2 classes
            return clazz.indexOf('select2-') !== 0;
        });
        var replacements = destinationClasses.concat(sourceClasses);
        dest.setAttribute('class', replacements.join(' '));
    };
    Utils.geElementParents = function (e) {
        var result = [];
        for (var p = e && e.parentElement; p; p = p.parentElement) {
            result.push(p);
        }
        return result;
    };
    Utils.detach = function (node) {
        if (node && node.parentElement) {
            return node.parentElement.removeChild(node);
        }
        return null;
    };
    Utils.elementEmpty = function (el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
        return el;
    };
    Utils.getLastElement = function (container, selector) {
        return Array.from(container.querySelectorAll(selector)).pop();
    };
    Utils.__cache = {};
    return Utils;
}());
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map